import {DEV_COUNTER_MY_TRACKER_ID} from '@dev-landing/constants';

import {logTmrEvent, logYmEvent} from '@dev-landing/analytics/analytics';
import {EVENTS} from '@dev-landing/analytics/events';

export const useButtonClick = () => {
  const logButtonClick = (text: string, ymEvent?: string) => {
    logTmrEvent({
      trackerId: DEV_COUNTER_MY_TRACKER_ID,
      logEvent: EVENTS.RUSTORE_BUTTON_CLICKED,
      params: {
        buttonName: text,
      },
    });

    logTmrEvent({
      logEvent: EVENTS.devLandingClick,
      params: {
        button_text: text,
      },
    });

    if (ymEvent) {
      logYmEvent(ymEvent);
    }
  };

  return {logButtonClick};
};
